import { IconButton, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import ListIcon from '@material-ui/icons/Edit'
import { openModalEditarPaqueteAction } from "../../../ducks/proveedorTerrestreDuck"

const BEditar = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(openModalEditarPaqueteAction({
          open: true,
          paquete
        }))
    }
    
    return (
        <Tooltip title="Editar">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <ListIcon color="primary" />
            </IconButton>
        </Tooltip>
    )
}

export default BEditar